// @ts-check
import { Text } from '~/design-system';
import { Trans } from '@lingui/macro';

/**
 * Used to get the import label based on the given type
 * @param {object} props
 * @param {string} props.type
 * @returns
 */
export default function ImportTypeLabel({ type }) {
  switch (type) {
    case 'productMasterListImport':
      return (
        <Text variant="smallest">
          <Trans>Product master list</Trans>
        </Text>
      );
    case 'productExternalIdImport':
      return (
        <Text variant="smallest">
          <Trans>External IDs</Trans>
        </Text>
      );
    case 'productInternalIdImport':
      return (
        <Text variant="smallest">
          <Trans>Internal IDs</Trans>
        </Text>
      );
    case 'partnerAliasImport':
      return (
        <Text variant="smallest">
          <Trans>Partner Aliases</Trans>
        </Text>
      );
    case 'productDataImport':
      return (
        <Text variant="smallest">
          <Trans>Legacy Product update import</Trans>
        </Text>
      );
    // case 'elabelsUpdateImport':
    //   return (
    //     <Text variant="smallest">
    //       <Trans>E-labels data import</Trans>
    //     </Text>
    //   );
    case 'productCreationImport':
      return (
        <Text variant="smallest">
          <Trans>New products import</Trans>
        </Text>
      );
    // case 'productImport':
    //   return (
    //     <Text variant="smallest">
    //       <Trans>All-in-one products import</Trans>
    //     </Text>
    //   );
    case 'productAllInOneImport':
      return (
        <Text variant="smallest">
          <Trans>Products Data Import</Trans>
        </Text>
      );
    case 'portfolioProductExternalIdImport':
      return (
        <Text variant="smallest">
          <Trans>Unique External ID import</Trans>
        </Text>
      );
    case 'productListImport':
      return (
        <Text variant="smallest">
          <Trans>Product list import</Trans>
        </Text>
      );
    default:
      return (
        <Text variant="smallest">
          <Trans>Unknown type</Trans>
        </Text>
      );
  }
}
